<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->

<crucible-dialog
  [dialogTitle]="data.card?.id ? 'Edit Card' : 'Add Card'"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
  @if (data && data.card) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput [(ngModel)]="data.card.name" placeholder="Name">
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Card Description</mat-label>
            <input type="text" matInput [(ngModel)]="data.card.description" placeholder="Card Description">
          </mat-form-field>
        </div>
      </div>
      @if (!data.card.isTemplate) {
        <div class="add-margin">
          <div>
            <mat-form-field class="full-width">
              <mat-label>Move</mat-label>
              <mat-select placeholder="Move" [(ngModel)]="data.card.move">
                @for (move of data.moveList; track move) {
                  <mat-option [value]="move.moveNumber" title="{{ move.description}}">
                    {{ move.moveNumber }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
    </div>
  }
</crucible-dialog>
